import { Injectable } from '@angular/core';
import { MainService } from './portal/service/main.service'
import { session } from '../environments/environment.session';
import { Utf8EncodingService } from './md/service/utf8-encoding.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(public mainService: MainService,private utf8EncodingService:Utf8EncodingService) { }

  erpUser:any;
  allComponentCode:any = [];
  public async isAuthenticated() {
    // if(!session?.erpUser) return;
    this.erpUser = this.utf8EncodingService.decodeFromUtf8((session.erpUser));

    this.allComponentCode = this.erpUser.assigned_component;

    if (this.allComponentCode == undefined || this.allComponentCode.length == 0) {
      this.allComponentCode = await this.getAllAssignedComponent(this.erpUser.b_acct_id, this.erpUser.role_cd);

      var erpUser1 = this.utf8EncodingService.decodeFromUtf8((session.erpUser));

      erpUser1['assigned_component'] = this.allComponentCode;
      // session['erpUser']=btoa(JSON.stringify(erpUser1));
      session['erpUser']=this.utf8EncodingService.encodeToUtf8(JSON.stringify(erpUser1));
    }
    let ComponentCode:any = this.mainService.componentCode;
    if (this.allComponentCode.indexOf(ComponentCode) < 0) {
      return false;
    } else {
      return true;
    }

  }

  async getAllAssignedComponent(b_acct_id:any, role_cd:any) {
    let obj:any = new Object();
    obj['b_acct_id'] = b_acct_id;
    obj['role_cd'] = role_cd;
    var allComponentCode1 = [];
    var resp = await this.mainService.getAllAssignedComponents(JSON.stringify(obj));
    if (resp['error'] == false) {
      for (let i = 0; i < resp['data'].length; i++) {
        allComponentCode1.push(resp['data'][i]['resource_cd'])
      }
    } else {

    }
    return allComponentCode1;


  }
}
